export class DelphiSSOSender {
  constructor(iframeId, token, options = {}) {
    this.iframeId = iframeId
    this.token = token
    this.maxRetries = options.maxRetries || 5
    this.retryDelay = options.retryDelay || 500
    this.loadDelay = options.loadDelay || 100
    this.iframe = null
    this.attempts = 0
    this.targetOrigin = 'https://embed.delphi.ai'
  }

  async findTargetIframe() {
    return new Promise((resolve, reject) => {
      let tries = 0
      const maxTries = 20

      const check = () => {
        const container = document.getElementById(this.iframeId)
        const frames = container?.querySelectorAll('iframe') || []

        const embedFrame =
          Array.from(frames).find((f) => f.src && f.src.includes('embed.delphi.ai')) ||
          frames[frames.length - 1]

        if (embedFrame) return resolve(embedFrame)

        if (++tries >= maxTries) {
          return reject(new Error(`Embed iframe not found in #${this.iframeId}`))
        }
        setTimeout(check, 100)
      }
      check()
    })
  }

  sendToken() {
    if (!this.iframe) return

    const targetOrigin = this.attempts < 2 ? '*' : 'https://embed.delphi.ai'

    this.iframe.contentWindow?.postMessage({ type: 'sso_login', token: this.token }, targetOrigin)

    // console.log(`[DelphiSSO] Token sent (attempt ${this.attempts + 1}) to:`, targetOrigin)
  }

  async initialize() {
    this.iframe = await this.findTargetIframe()

    this.iframe.addEventListener('load', () => {
      setTimeout(() => this.sendToken(), this.loadDelay)
    })

    const doc = this.iframe.contentDocument
    if (doc?.readyState === 'complete') {
      setTimeout(() => this.sendToken(), this.loadDelay)
    }

    const interval = setInterval(() => {
      this.sendToken()
      if (++this.attempts >= this.maxRetries) clearInterval(interval)
    }, this.retryDelay)
  }
}
